import React from 'react';
import { View, Text, StyleSheet, Image, ScrollView, Pressable, Platform, Dimensions } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { BackgroundGradient, Loader, Button, TextInputContainer, Validate, MFAModal, SafeAreaView, Storage, Alert } from '../../../components';
import * as rtApi from '../../../components/Api';
import { formatCurrency } from '../../../utils/Functions';
import UserState from '../../../src/contexts/UserState';
import moment from 'moment';
import * as WebBrowser from 'expo-web-browser';
// import * as SecureStore from 'expo-secure-store';
import * as LocalAthentication from 'expo-local-authentication';
import { FontAwesome5 } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import { app } from '../../../constants/DevProd';
import { WebView } from 'react-native-webview';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const PaymentScreen = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);

  const [rtJWT, setRtJWT] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [checkedBalance, setCheckedBalance] = React.useState(false);
  const [chequeWebStyle, setChequeWebStyle] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});

  const [unassignedFunds, setUnassignedFunds] = React.useState(0);
  // const [remainingFunds, setRemainingFunds] = React.useState(0);

  const [project, setProject] = React.useState(null);
  const [milestone, setMilestone] = React.useState(null);

  const [totalAmount, setTotalAmount] = React.useState(null);
  const [fee, setFee] = React.useState(null);
  const [wireTransferFee, setWireTransferFee] = React.useState(20);
  const [amountDisplay, setAmountDisplay] = React.useState('');
  // const [hst, setHst] = React.useState(0);

  const [showMFA, setShowMFA] = React.useState(false);
  const [MFACode, setMFACode] = React.useState('');
  const [MFATrusted, setMFATrusted] = React.useState(true);
  const [MFARequired, setMFARequired] = React.useState(false);

  const [cardNumber, setCardNumber] = React.useState('');
  const [cardName, setCardName] = React.useState('');
  const [cardExpiry, setCardExpiry] = React.useState('');
  const [cardCvv, setCardCvv] = React.useState('');
  const defaultIsInvalid = {
    cardNumber: false,
    cardName: false,
    cardExpiry: false,
    cardCvv: false,
  };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  let textInputs = {
    cardNumber: React.useRef(null),
    cardName: React.useRef(null),
    cardExpiry: React.useRef(null),
    cardCvv: React.useRef(null),
  };
  // const [milestone, setMilestone] = React.useState({});

  
  const linkTo = useLinkTo();
  const windowWidth = Dimensions.get('window').width;
  const insets = useSafeAreaInsets();
  
  const buttonText = "I've Sent the Money";

  // const fee = 23;
  // const hst = 2.99;

  // React.useEffect(() => {
  //   // if (route.params.paymentMethod === 'Account Balance'){
  //   //   getMoney();
  //   // }
  //   // return () => rtApi.cancel();
  //   console.log('paymentMethod: ', route.params.paymentMethod);
  // }, [route.params.paymentMethod]);

  React.useEffect(() => {
    if (Platform.OS === 'web') {
      window.addEventListener("message", (event) => {
        // console.log('message: ', event);
        if (event.origin === "https://app.dev.renovationtrust.com" || event.origin === "https://app.renovationtrust.com" || event.origin === "https://dev.renovationtrust.com" || event.origin === "https://renovationtrust.com") {
          console.log('message: ', event);
          onMessage(event.data);
        }
      }, false);
    }
  }, []);

  React.useEffect(() => {
    if (route.params.projectId){
      getProject();
    }
    getRtJwt();
    return () => rtApi.cancel();
  }, [route.params.projectId]);

  React.useEffect(() => {
    if(project && milestone){
      getFeeTax();
      // getMoney();
    }
  }, [project, milestone]);

  React.useEffect(() => {
    console.log('milestone: ', milestone);
  }, [milestone]);

  React.useEffect(() => {
    if(fee !== null){
      getMoney();
    }
  }, [fee]);

  React.useEffect(() => {
    getAmountDisplay();
  }, [totalAmount])

  React.useEffect(() => {
    checkMFACode();
  }, [MFACode]);

  React.useEffect(() => {
    calculateTotalAmount();
  }, [milestone, fee, unassignedFunds]);

  React.useEffect(() => {
    setFee(null);
    setUnassignedFunds(0);
    setChequeWebStyle(chequeImgStyle(windowWidth));
    if (Platform.OS === 'web') {
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        subscription.remove();
        // Dimensions.removeEventListener('change', onChangeDimensions);
      }
    }
  }, []);

  const getRtJwt = async () => {
    setRtJWT(await Storage.getItem('rtJWT'));
  }

  const onChangeDimensions = ({ window, screen }) => {
    setChequeWebStyle(chequeImgStyle(window.width));
  };

  // React.useEffect(() => {
  //   setTotalAmount(parseFloat(route.params.milestone.amount_value) + fee + hst);
  // }, [route.params.milestone]);

  const getProject = () => {
    console.log('getProject', route.params);
    setLoading(true);
    rtApi.get(`agreements/${route.params.projectId}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('got project !', data);
      setProject(data.agreement);
      setMilestone(data.agreement.stages.filter(s => s.stage_id == route.params.milestoneId)[0]);
      // setIsContractor(data.agreement.contractor_id == user.id);
    }).catch(err => {
      console.log('milestone getProject catch: ', err);
    }).finally(() => {
      // setLoading(false);
    });
  }
  const getAmountDisplay = () => {
    if(!totalAmount){ return; }
    rtApi.get(`money/textualize/${totalAmount}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setAmountDisplay(data.amount);
    }).catch(err => {
      console.log('getFeeTax catch: ', err);
    }).finally(() =>{
      if(route.params.paymentMethod !== 'credit_card'){
        setLoading(false);
      }
    });
  }

  const screenOutput = () => {
    switch(route.params.paymentMethod){
      case 'account_balance':
        return myMoney();
      case 'e_transfer':
        return eTransfer();
      case 'bill_payment':
        return billPayment();
      case 'credit_or_debit_card':
        return creditDebitCard();
      case 'wire_transfer':
        return wireTransfer();
      case 'deposit_at_your_local_cibc_branch':
        return bankDeposit();
      case 'mail_a_cheque':
        return mailCheque();
      default:
        return <Text style={[CS.smallTitle, CS.lightText]}>Can't find payment method ({route.params.paymentMethod}) for amount {formatCurrency(totalAmount)}</Text>
    }
  }

  // fee tax
  const getFeeTax = () => {
    console.log('getFeeTax()');
    let payor = project.who_pays === '50_50' ? 'both' : project.who_pays;
    rtApi.get(`money/calculator?amount=${milestone.amount}&payor=${payor}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setFee(data.fee_homeowner);
      // setHst(data.tax);
      // setTotalAmount(parseFloat(route.params.milestone.amount_value) + data.fee_homeowner + data.tax);
      // other fees
      // let otherAmount = 0;
      // if(route.params.paymentMethod === 'wire_transfer'){
      //   otherAmount += wireTransferFee;
      // }
      // // outstanding balance
      // let balanceAmount = 0;
      // if(unassignedFunds < 0){
      //   balanceAmount = unassignedFunds * -1;
      // }
      // setTotalAmount(parseFloat(milestone.amount) + data.fee_homeowner + otherAmount + balanceAmount);
      // getMoney();
    }).catch(err => {
      console.log('getFeeTax catch: ', err);
    });
  }
  const calculateTotalAmount = () => {
    if(milestone && milestone.amount){
      let otherAmount = 0;
      if (route.params.paymentMethod === 'wire_transfer') {
        otherAmount += wireTransferFee;
      }
      // outstanding balance
      let balanceAmount = 0;
      if (unassignedFunds < 0) {
        balanceAmount = unassignedFunds * -1;
      }
      setTotalAmount(parseFloat(milestone.amount) + fee + otherAmount + balanceAmount);
    }
  }

  // My Money (Account Balance)
  const getMoney = () => {
    console.log('getMoney()');
    // setLoading(true);
    rtApi.get('money')
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getMoney(): ', data.unassigned_funds, totalAmount, parseFloat(data.unassigned_funds) < parseFloat(totalAmount), fee);
      setUnassignedFunds(data.unassigned_funds);
      // setUnassignedFunds(-25.76); //testing
      // let remaining = parseFloat(data.unassigned_funds) - (parseFloat(route.params.milestone.amount_value) + fee + hst);
      let remaining = parseFloat(data.unassigned_funds) - (parseFloat(milestone.amount) + fee);
      console.log('remaining: ', remaining);
      // setRemainingFunds(remaining)
      // if(remaining < 0){
      //   setDisabled(true);
      // }
      if (remaining > 0) {
        setDisabled(false);
      }
      setCheckedBalance(true);
    }).catch(err => {
      console.log('error: ', err)
    }).finally(() => {
      // setLoading(false);
    });
  }
  const myMoney = () => {
    return (
      <>
        
        <View style={[CS.rowContainer, styles.amountContainer, { marginTop: 20 }]}>
          <Text style={[CS.mediumText, CS.lightBlueText]}>Account Balance</Text>
          <Text style={[CS.mediumText, CS.boldText, CS.lightText, CS.rightText, styles.amount]}>{formatCurrency(unassignedFunds)}</Text>
        </View>
        {(disabled && checkedBalance) && 
          <Text style={[CS.miniText, CS.redText, { marginTop: 10 }]}>** You don't have enough money in your account to fund this project. Please select a different payment method.</Text>
        }
        <Button text='Pay Now' onPress={() => payMyMoney} disabled={disabled} style={styles.button} />
      </>
    )
  }
  const payMyMoney = async () => {
    console.log(`Paying ${formatCurrency(milestone.amount)} from my account balance.`);
    // let useLocalAuthentication = await SecureStore.getItemAsync('useLocalAuthentication');
    let useLocalAuthentication = await Storage.getItem('useLocalAuthentication');
    console.log('useLocalAuthentication: ', useLocalAuthentication);
    if(useLocalAuthentication === 'yes'){
      payUsingLocalAuthentication();
      // payTriggerMFA(); // testing
    }else{
      payTriggerMFA();
    }
  }
  const payUsingLocalAuthentication = async () => {
    console.log('payUsingLocalAuthentication');
    let authenticateAsync = await LocalAthentication.authenticateAsync({
      promptMessage: 'Fund this milestone using your account balance'
    });
    console.log('authenticateAsync', authenticateAsync);
    if (authenticateAsync.success) {
      console.log('success!')
      try{
        let payResult = await postFund('account_balance', false);
        if (payResult.result) {
          successAlert(`The amount of '${formatCurrency(totalAmount)}' will be funded instantly from your account balance for the '${milestone.title}' stage of your '${project.homeowner_title}' project`);
        }
      }catch(err){
        console.log(err);
      }
    }
  }
  const payTriggerMFA = async () => {
    // trigger mfa code generation
    try {
      let payResult = await postFund('account_balance');
      console.log('payResult: ', payResult);
      if (payResult.result && payResult.MFA) {
        // successAlert("The amount will be funded instantly from your account balance");
        setMFARequired(true);
        setShowMFA(true);
      }
    } catch (err) {
      console.log(err);
    }
  }
  const checkMFACode = () => {
    console.log('MFACode', MFACode);
    if (String(MFACode).length === 6) {
      setShowMFA(false);
      if (MFARequired) {
        console.log('use the mfa code: ', MFACode);
        payUsingMfa();
      }
    }
  }
  const payUsingMfa = async () => {
    try {
      let payResult = await postFund('account_balance', MFACode);
      if (payResult.result) {
        setShowMFA(false);
        // successAlert("You have funded this project");
        successAlert(`You have successfully funded '${formatCurrency(totalAmount)}' for the '${milestone.title}' stage of your '${project.homeowner_title}' project`);
      }
    } catch (err) {
      setMFACode('');
      setShowMFA(true);
      console.log(err);
    }
  }

  // e-transfer
  const eTransfer = () => {
    return (
      <>
        <Text style={[CS.smallTitle, CS.lightText]}>Email {formatCurrency(totalAmount)} to payments@renovationtrust.com</Text>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Open your banking app or log into your bank's website.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Navigate to <Text style={[CS.boldText, CS.lightText]}>Interac e-Transfers</Text>.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>3.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Have you already added us as a Payee?</Text>
        </View>
        <View style={{ marginLeft: 30}}>
          <View style={[styles.container, { marginBottom: 10 }]}>
            <Text style={[CS.mediumText, CS.boldText, CS.lightText, { marginBottom: 5 }]}>Yes</Text>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Search for <Text style={[CS.boldText, CS.lightText]}>Renovation Trust</Text> in your list of interac contacts.</Text>
            </View>
            <View style={[styles.listContainer, styles.listContainerNoMargin]}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Make a payment of <Text style={[CS.boldText, CS.lightText]}>{formatCurrency(totalAmount)}</Text>.</Text>
            </View>
          </View>
          <View style={[styles.container, { marginBottom: 10 }]}>
            <Text style={[CS.mediumText, CS.boldText, CS.lightText, { marginBottom: 5 }]}>No</Text>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Add a new payee with the following details.</Text>
            </View>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}></Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Name: <Text style={[CS.boldText, CS.lightText]}>Renovation Trust</Text></Text>
            </View>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}></Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Notify By: <Text style={[CS.boldText, CS.lightText]}>Email</Text></Text>
            </View>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}></Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Email Address: <Text style={[CS.boldText, CS.lightText]}>payments@renovationtrust.com</Text></Text>
            </View>
            <View style={[styles.listContainer, styles.listContainerNoMargin]}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Make a payment of <Text style={[CS.boldText, CS.lightText]}>{formatCurrency(totalAmount)}</Text>.</Text>
            </View>
          </View>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber, { marginTop: 3 }]}>4.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Select the yellow <View style={{ paddingVertical: 5, paddingHorizontal: 10, borderRadius: 6, backgroundColor: Colors.yellow, marginTop: -7 }}><Text style={[CS.boldText, { textTransform: 'uppercase', color: Colors.black }]}>I've sent the money</Text></View> button below.</Text>
        </View>
        <View style={styles.container}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>We'll notify you as soon as we receive the deposit.</Text>
        </View>
        <Button text={buttonText} onPress={() => payEtransfer} style={styles.button} />
      </>
    )
  }
  const payEtransfer = async () => {
    try {
      let payResult = await postFund('e-transfer');
      if(payResult.result){
        successAlert("We'll notify you as soon as we receive the payment.");
      }
    } catch (err) {
      console.log(err);
    }
  }

  // Bill Payment
  const billPayment = () => {
    return (
      <>
        <Text style={[CS.smallTitle, CS.lightText]}>Make a {formatCurrency(totalAmount)} payment to Renovation Trust</Text>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Open your banking app or log into your bank's website.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Navigate to <Text style={[CS.boldText, CS.lightText]}>Bill Payments</Text>.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>3.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Have you already added us to your bill payments?</Text>
        </View>
        <View style={{ marginLeft: 30 }}>
          <View style={[styles.container, { marginBottom: 10 }]}>
            <Text style={[CS.mediumText, CS.boldText, CS.lightText, { marginBottom: 5 }]}>Yes</Text>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Search for <Text style={[CS.boldText, CS.lightText]}>Renovation Trust</Text> in your list of bill payees.</Text>
            </View>
            <View style={[styles.listContainer, styles.listContainerNoMargin]}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Make a payment of <Text style={[CS.boldText, CS.lightText]}>{formatCurrency(totalAmount)}</Text>.</Text>
            </View>
          </View>
          <View style={[styles.container, { marginBottom: 10 }]}>
            <Text style={[CS.mediumText, CS.boldText, CS.lightText, { marginBottom: 5 }]}>No</Text>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Search <Text style={[CS.boldText, CS.lightText]}>Renovation Trust</Text>.</Text>
            </View>
            <View style={styles.listContainer}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>You will be asked to enter Account Number: <Text style={[CS.boldText, CS.lightText, styles.accountNumber]}>{user.account_id}</Text>.</Text>
            </View>
            <View style={[styles.listContainer, styles.listContainerNoMargin]}>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>3.</Text>
              <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Make a payment of <Text style={[CS.boldText, CS.lightText]}>{formatCurrency(totalAmount)}</Text>.</Text>
            </View>
          </View>
        </View>
        {/* <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>4.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>We'll notify you as soon as we receive the payment.</Text>
        </View> */}
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber, { marginTop: 3 }]}>4.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Select the yellow <View style={{ paddingVertical: 5, paddingHorizontal: 10, borderRadius: 6, backgroundColor: Colors.yellow, marginTop: -7 }}><Text style={[CS.boldText, { textTransform: 'uppercase', color: Colors.black }]}>I've sent the money</Text></View> button below.</Text>
        </View>
        <View style={styles.container}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>We'll notify you as soon as we receive the deposit.</Text>
        </View>
        <Button text={buttonText} onPress={() => payBillPayment} style={styles.button} />
      </>
    )
  }
  const payBillPayment = async () => {
    try {
      let payResult = await postFund('bill_payment');
      if (payResult.result) {
        successAlert("We'll notify you as soon as we receive the payment.");
      }
    } catch (err) {
      console.log(err);
    }
  }

  // Credit or Debit Card
  const creditDebitCard = () => {
    if(Platform.OS === 'web'){
      return (
        <iframe
          allow='payment *'
          src={`${app.base}credit_card.php?jwt=${rtJWT}&stage_id=${route.params.milestoneId}`}
          frameborder='0'
          width='100%'
          height='200px'
        />
      )
    }
    return (
      <WebView
        style={{ height: 200, width: '100%', backgroundColor: 'transparent' }}
        originWhitelist={['*']}
        javaScriptEnabled
        onMessage={onNativeMessage}
        // source={{
        //   html: `<html>
        //           <head>
        //             <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no">
        //           </head>
        //           <body style='margin: 0'>
        //             <iframe
        //               allow='payment *'
        //               src='${app.base}credit_card.php?jwt=${rtJWT}&stage_id=${route.params.milestoneId}'
        //               frameborder='0'
        //               width='100%'
        //               height='200px'
        //             />
        //           </body>
        //         </html>`
        // }}
        // source={{
        //   html: `<html>
        //           <head>
        //             <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no">
        //             <script>
        //               function test() {
        //                 if(window.ReactNativeWebView){ window.ReactNativeWebView.postMessage(JSON.stringify({ loading: true })); }
        //                 setTimeout(() => {
        //                   if(window.ReactNativeWebView){ window.ReactNativeWebView.postMessage(JSON.stringify({ loading: false })); }
        //                 }, 3000)
        //               }
        //             </script>
        //           </head>
        //           <body style='display: flex; align-items: center; justify-content: center;'>
        //             <button id="test" type='button' onclick="test()">Test</button>
        //           </body>
        //         </html>`
        // }}
        source={{
          uri: `${app.base}credit_card.php?jwt=${rtJWT}&stage_id=${route.params.milestoneId}`
        }}
      />
    )
    // return (
    //   <>
    //    <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Card Number</Text>
    //     <TextInputContainer
    //       placeholder='1234 5678 9123'
    //       onChangeText={(t) => onChangeCardNumber(t)}
    //       inputRef={textInputs.cardNumber}
    //       isInvalid={isInvalid.cardNumber}
    //       value={cardNumber}
    //       autoCorrect={false}
    //       spellCheck={false}
    //       // selectTextOnFocus={true}
    //       onSubmitEditing={() => textInputs.cardName.current.focus()}
    //       returnKeyType='next'
    //       editable={!loading}
    //     />
    //     <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Card Holder Name</Text>
    //     <TextInputContainer
    //       placeholder='John M. Doe'
    //       onChangeText={(t) => onChangeCardName(t)}
    //       inputRef={textInputs.cardName}
    //       isInvalid={isInvalid.cardName}
    //       value={cardNumber}
    //       autoCorrect={false}
    //       spellCheck={false}
    //       // selectTextOnFocus={true}
    //       onSubmitEditing={() => textInputs.cardName.current.focus()}
    //       returnKeyType='next'
    //       editable={!loading}
    //     />
    //     <View style={CS.rowContainer}>
    //       <View style={{ marginRight: 5, flex: 1}}>
    //         <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Expiry Date</Text>
    //         <TextInputContainer
    //           placeholder='MM/YY'
    //           onChangeText={(t) => onChangeCardExpiry(t)}
    //           inputRef={textInputs.cardExpiry}
    //           isInvalid={isInvalid.cardExpiry}
    //           value={cardExpiry}
    //           autoCorrect={false}
    //           spellCheck={false}
    //           // selectTextOnFocus={true}
    //           onSubmitEditing={() => textInputs.cardCvv.current.focus()}
    //           returnKeyType='next'
    //           editable={!loading}
    //           maxLength={5}
    //           keyboardType='numeric'
    //         />
    //       </View>
    //       <View style={{ marginLeft: 5, flex: 1 }}>
    //         <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>CVV</Text>
    //         <TextInputContainer
    //           placeholder='1234'
    //           onChangeText={(t) => onChangeCardCvv(t)}
    //           inputRef={textInputs.cardCvv}
    //           isInvalid={isInvalid.cardCvv}
    //           value={cardCvv}
    //           autoCorrect={false}
    //           spellCheck={false}
    //           // selectTextOnFocus={true}
    //           onSubmitEditing={checkCreditDebit}
    //           returnKeyType='done'
    //           editable={!loading}
    //           maxLength={4}
    //           keyboardType='numeric'
    //         />
    //       </View>
    //     </View>
    //     <Button text='Pay Now' onPress={() => checkCreditDebit} style={styles.button} />
    //   </>
    // )
  }
  const onNativeMessage = (event) => {
    const data = JSON.parse(event.nativeEvent.data)
    onMessage(data);
  }
  const onMessage = (data) => {
    if(data){
      if(data.loading !== undefined){
        setLoading(data.loading);
      }
      switch(data.action){
        case 'complete':
          successAlert("We'll notify you as soon as we receive the payment.", () => linkTo('/projects'));
          break;
      }
    }
  }
  
  // const onChangeCardNumber = (input) => {
  //   if (isInvalid.cardNumber && Validate.CardNumber(input)) {
  //     setIsInvalid(prevState => { return { ...prevState, cardNumber: false } });
  //   }
  //   setCardNumber(input);
  // };
  // const onChangeCardName = (input) => {
  //   if (isInvalid.cardName && Validate.Name(cardName)) {
  //     setIsInvalid(prevState => { return { ...prevState, cardName: false } });
  //   }
  //   setCardName(input);
  // };
  // const onChangeCardExpiry = (input) => {
  //   if (isInvalid.cardExpiry && Validate.CardExpiry(cardExpiry)) {
  //     setIsInvalid(prevState => { return { ...prevState, cardExpiry: false } });
  //   }
  //   setCardExpiry(input);
  // };
  // const onChangeCardCvv = (input) => {
  //   if (isInvalid.cardCvv && Validate.CardCvv(cardCvv)) {
  //     setIsInvalid(prevState => { return { ...prevState, cardCvv: false } });
  //   }
  //   setCardCvv(input);
  // };
  // const checkCreditDebit = () => {
  //   console.log(`Paying ${formatCurrency(milestone.amount)} from credit debit card.`);
  //   console.log(`Card Number: ${cardNumber}`);
  //   console.log(`Card Name: ${cardName}`);
  //   console.log(`Card Expiry: ${cardExpiry}`);
  //   console.log(`Card Cvv: ${cardCvv}`);
  //   if(cardNumber.length < 9){
  //     setIsInvalid(prevState => { return { ...prevState, cardNumber: true } });
  //     textInputs.cardNumber.current.focus();
  //     return false;
  //   }
  //   if(cardName.length < 2){
  //     setIsInvalid(prevState => { return { ...prevState, cardName: true } });
  //     textInputs.cardName.current.focus();
  //     return false;
  //   }
  //   if (cardName.length < 2) {
  //     setIsInvalid(prevState => { return { ...prevState, cardName: true } });
  //     textInputs.cardName.current.focus();
  //     return false;
  //   }
  //   payCreditDebit();
  // }
  // const payCreditDebit = async () => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 2500);

  //   // let payResult = await postFund('credit_card');
  //   // if (payResult.result) {
  //   //   successAlert("We'll notify you as soon as we receive the payment.");
  //   // }
  // }

  // Wire Transfer
  const wireTransfer = () => {
    return (
      <>
        <Text style={[CS.mediumTitle, CS.lightText, { marginBottom: 3 }]}>Wire Transfer</Text>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>Use the following information to initiate a wire transfer from your bank.</Text>
        <View style={[styles.container, { marginBottom: 20 }]}>
          <Text style={[CS.mediumText, CS.lightBlueText, { marginBottom: 10 }]}>Recipient Information</Text>
          <View style={{ marginLeft: 16, flex: 1 }}>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Name: <Text style={[CS.boldText, CS.lightText]}>Renovation Trust Corp</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Address: <Text style={[CS.boldText, CS.lightText]}>7050 Telford Way, Unit 102. Mississauga, ON, Canada L5S 1V7</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Phone: <Text style={[CS.boldText, CS.lightText]}>(800)673-9716</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Account #: <Text style={[CS.boldText, CS.lightText]}>1014501</Text></Text>
          </View>
        </View>
        <View style={styles.container}>
          <Text style={[CS.mediumText, CS.lightBlueText, { marginBottom: 10 }]}>Destination Information</Text>
          <View style={{ marginLeft: 16, flex: 1 }}>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Name: <Text style={[CS.boldText, CS.lightText]}>CIBC</Text></Text>
            {/* <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Address: <Text style={[CS.boldText, CS.lightText]}>305 Milner Avenue, 5th Floor. Scarborough, ON, Canada</Text></Text> */}
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Address: <Text style={[CS.boldText, CS.lightText]}>501 Dundas St. West. Oakville, ON. L6M 1L9</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Institution #: <Text style={[CS.boldText, CS.lightText]}>010</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Swift code: <Text style={[CS.boldText, CS.lightText]}>CIBCCATT</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Branch Transit #: <Text style={[CS.boldText, CS.lightText]}>04162</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Routing #: <Text style={[CS.boldText, CS.lightText]}>001004162</Text></Text>
          </View>
        </View>
        <Button text={buttonText} onPress={() => payWireTransfer} style={styles.button} />
      </>
    )
  }
  const payWireTransfer = async () => {
    try {
      let payResult = await postFund('wire_transfer');
      if (payResult.result) {
        successAlert("We'll notify you as soon as we receive the payment.");
      }
    } catch (err) {
      console.log(err);
    }
  }

  // Deposit at Your Local CIBC Branch
  const bankDeposit = () => {
    return (
      <>
        <Text style={[CS.smallTitle, CS.lightText]}>Deposit at Your Local CIBC Branch</Text>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Visit your local CIBC branch or find the nearest one <Text style={CS.yellowText} onPress={openCibcLocations}>here</Text>.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Show the teller this information.</Text>
        </View>
        <View style={{ marginLeft: 30 }}>
          <View style={[styles.container, { marginBottom: 10 }]}>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Please deposit <Text style={[CS.boldText, CS.lightText]}>{formatCurrency(totalAmount)}</Text> into the following account.</Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Account: <Text style={[CS.boldText, CS.lightText]}>Renovation Trust</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Institution #: <Text style={[CS.boldText, CS.lightText]}>010</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Transit #: <Text style={[CS.boldText, CS.lightText]}>04162</Text></Text>
            <Text style={[CS.smallText, CS.lightBlueText]}>Account #: <Text style={[CS.boldText, CS.lightText]}>1014501</Text></Text>
          </View>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber, { marginTop: 3 }]}>3.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Select the yellow <View style={{ paddingVertical: 5, paddingHorizontal: 10, borderRadius: 6, backgroundColor: Colors.yellow, marginTop: -7 }}><Text style={[CS.boldText, { textTransform: 'uppercase', color: Colors.black }]}>I've sent the money</Text></View> button below.</Text>
        </View>
        <View style={styles.container}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>We'll notify you as soon as we receive the deposit.</Text>
        </View>
        <Button text={buttonText} onPress={() => payBankDeposit} style={styles.button} />
      </>
    )
  }
  const openCibcLocations = async () => {
    let url = 'https://locations.cibc.com/search/[PR]/[CITY]?t=&q=[CITY]%2C+[PR]&filters=filter-_-Branch';
    console.log('openCibcLocations: ', url);
    url = url.replace(/\[PR]/g, user.state);
    url = url.replace(/\[CITY]/g, user.city);
    console.log('url: ', url);
    await WebBrowser.openBrowserAsync(url);
    // await WebBrowser.openBrowserAsync('https://locations.cibc.com/');
  }
  const payBankDeposit = async () => {
    try {
      let payResult = await postFund('branch_deposit');
      if (payResult.result) {
        successAlert("We'll notify you as soon as we receive the payment.");
      }
    } catch (err) {
      console.log(err);
    }
  }

  // Mail a Cheque
  const mailCheque = () => {
    return (
      <>
        <Text style={[CS.smallTitle, CS.lightText]}>Write a Cheque</Text>
        <Image source={require('../../../assets/img/blank_cheque.jpg')} style={[CS.responsiveImage, styles.chequeImg, chequeWebStyle]} />
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>1.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Pay to: <Text style={[CS.boldText, CS.lightText]}>Renovation Trust Corp.</Text></Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>2.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Amount: <Text style={[CS.boldText, CS.lightText]}>{amountDisplay}</Text>.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>3.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Amount: <Text style={[CS.boldText, CS.lightText]}>{formatCurrency(totalAmount)}</Text>.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>4.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Memo: <Text style={[CS.boldText, CS.lightText, styles.accountNumber]}>{user.account_id}</Text>.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>5.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Date: <Text style={[CS.boldText, CS.lightText]}>{moment().format('YYYY-MM-DD')}</Text>.</Text>
        </View>
        <View style={styles.listContainer}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listNumber]}>6.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.listText]}>Signature: <Text style={[CS.boldText, CS.lightText, CS.italicText]}>{`${user.first_name} ${user.last_name}`}</Text>.</Text>
        </View>
        <Text style={[CS.smallTitle, CS.lightText]}>Mail it to</Text>
        <View style={[styles.container, { marginBottom: 10 }]}>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}><Text style={[CS.boldText, CS.lightText]}>Renovation Trust Corp.</Text></Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>7050 Telford Way. Unit 102.</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>Mississauga, ON</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 5 }]}>L5S 1V7</Text>
        </View>
        <Button text="I've Mailed the Cheque" onPress={() => payMailCheque} style={styles.button} />
      </>
    )
  }
  const payMailCheque = async () => {
    try {
      let payResult = await postFund('mail_cheque');
      if (payResult.result) {
        successAlert("We'll notify you as soon as we process the cheque.");
      }
    } catch (err) {
      console.log(err);
    }
  }
  const chequeImgStyle = (windowWidth) => {
    if(Platform.OS === 'web'){
      const ratio = 509 / 1125;
      const width = (windowWidth >= 768 ? 768 : windowWidth) - 20;
      console.log('chequeImgStyle: ', width, width * ratio)
      return {
        width: width,
        height: width * ratio,
      }
    }
    return {};
  }

  // General
  const postFund = (method, mfa) => {
    let methods = ['bill_payment', 'e-transfer', 'wire_transfer', 'branch_deposit', 'credit_card', 'account_balance', 'mail_cheque'];
    if(!methods.includes(method)){ return; }
    return new Promise((resolve, reject) => {
      setLoading(true);
      let fd = new FormData();
      if(method !== 'account_balance'){
        fd.append('amount', totalAmount);
      }
      if(mfa !== undefined){
        fd.append('MFA', mfa);
      }
      fd.append('method', method);
      // bill_payment, e-transfer, wire_transfer, branch_deposit, credit_card, account_balance, mail_cheque
      rtApi.post(`agreements/${route.params.projectId}/stages/${milestone.stage_id}/fund`, fd)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('postFund: ', data);
        setLoading(false);
        resolve(data);
      })
      .catch(err => {
        setLoading(false);
        reject(err);
      });
    });
  }
  const successAlert = (message, callback) => {
    console.log('successAlert message: ', message);
    setTimeout(() => {
      // Alert.alert(
      //   'Success',
      //   message,
      //   [
      //     {
      //       text: 'OK',
      //       onPress: () => goBackToProject()
      //     }
      //   ],
      //   { cancelable: false }
      // );
      setAlertOptions({
        visible: true,
        title: 'Success',
        message: message,
        buttons: [
          {
            text: 'OK',
            onPress: () => (callback !== undefined && typeof callback === 'function') ? callback() : goBackToProject(),
          },
        ]
      })
    }, 100);
  }
  const goBackToProject = () => {
    // linkTo('/projects');
    linkTo(`/project/${route.params.projectId}?refresh=${Math.floor(Math.random() * 1000)}`);
  }
  const amountBreakdown = () => {
    return (
      <View style={[styles.container, styles.amountBreakdownContainer]}>
        <View style={[CS.rowContainer, styles.amountContainer]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Funding Amount</Text>
          <Text style={[CS.smallText, CS.lightText, CS.rightText, styles.amount]}>{formatCurrency(milestone.amount)}</Text>
        </View>
        <View style={[CS.rowContainer, styles.amountContainer]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Protection Fee</Text>
          <Text style={[CS.smallText, CS.lightText, CS.rightText, styles.amount]}>{formatCurrency(fee)}</Text>
        </View>
        {route.params.paymentMethod === 'wire_transfer' ?
          <View style={[CS.rowContainer, styles.amountContainer]}>
            <Text style={[CS.smallText, CS.lightBlueText]}>Wire Transfer Fee</Text>
            <Text style={[CS.smallText, CS.lightText, CS.rightText, styles.amount]}>{formatCurrency(wireTransferFee)}</Text>
          </View>
          : null
        }
        {unassignedFunds < 0 &&
          <View style={[CS.rowContainer, styles.amountContainer]}>
            <Text style={[CS.smallText, CS.lightBlueText]}>Outstanding Balance</Text>
            <Text style={[CS.smallText, CS.lightText, CS.rightText, styles.amount]}>{formatCurrency(unassignedFunds * -1)}</Text>
          </View>
        }
        {/* <View style={[CS.rowContainer, styles.amountContainer, { marginBottom: 0 }]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>HST on Fee</Text>
          <Text style={[CS.smallText, CS.lightText, CS.rightText, styles.amount]}>{formatCurrency(hst)}</Text>
        </View> */}
        <View style={styles.separator}></View>
        <View style={[CS.rowContainer, styles.amountContainer, { marginBottom: 0 }]}>
          <Text style={[CS.mediumText, CS.boldText, CS.lightBlueText]}>Total Amount to Fund</Text>
          <Text style={[CS.mediumText, CS.boldText, CS.lightText, CS.rightText, styles.amount]}>{formatCurrency(totalAmount)}</Text>
        </View>
      </View>
    )
  }
  const cancelMFA = () => {
    setShowMFA(false);
    setMFACode(null);
    setMFARequired(false);
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo(`/project/${route.params.projectId}/milestone/${route.params.milestoneId}/method/${route.params.acceptCreditCards}`);
    }
  }

  return (
    <View style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <MFAModal
        show={showMFA}
        cancel={cancelMFA}
        setMFACode={setMFACode}
        MFACode={MFACode}
        setMFATrusted={setMFATrusted}
        showTrusted={false}
        MFATrusted={MFATrusted}
      />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      {(project && milestone) &&
        <View style={CS.innerContainer}>
          <ScrollView contentContainerStyle={{ paddingTop: insets.top, paddingBottom: insets.bottom }}>
            <Pressable onPress={goBack} style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1.0, marginVertical: 10 }]} hitSlop={10}>
              <FontAwesome5 name="arrow-left" size={24} color="white" />
            </Pressable>
            {amountBreakdown()}
            <View style={{marginBottom: 10 }}>
              {screenOutput()}
            </View>
          </ScrollView>
        </View>
      }
    </View>
  );

}

const styles = StyleSheet.create({
  largeAmount: {
    marginVertical: 20,
    fontSize: 48,
  },
  amountType: {
    marginBottom: 20,
  },
  amountContainer: {
    flex: 1,
    marginBottom: 5,
  },
  amount: {
    flex: 1,
  },
  button: {
    marginTop: 20,
  },
  separator: {
    borderWidth: 1,
    borderColor: Colors.lightGrey,
    marginVertical: 8,
  },
  separatorYellow: {
    borderWidth: 1,
    borderColor: Colors.yellow,
    marginVertical: 8,
  },
  listContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    // flexWrap: 'wrap',
    marginBottom: 10,
  },
  listContainerNoMargin: {
    marginBottom: 0,
  },
  listNumber: {
    width: 18,
    marginRight: 10,
  },
  listText: {
    flex: 1,
    // flexWrap: 'wrap',
  },
  inputLabel: {
    marginBottom: 5,
  },
  container: {
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Colors.textInputBackground,
  },
  amountBreakdownContainer: {
    // backgroundColor: 'rgba(255, 192, 68, 0.9)',
    // borderColor: Colors.yellow,
    marginBottom: 20,
  },
  chequeImg: {
    // width: 1125,
    // height: 509,
    aspectRatio: 1125 / 509,
    marginBottom: 20,
    borderRadius: 10,
  },
  accountNumber: {
    ...Platform.select({
      ios: {
        fontFamily: 'Courier New',
        fontSize: 20,
      },
      android: {
        fontFamily: 'monospace',
      },
      web: {
        fontFamily: 'Courier',
      }
    })
  }
});

export default PaymentScreen;